var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._t("default", null, {
        color: _vm.color,
        isSaved: _vm.isSaved,
        isSaving: _vm.isSaving,
        needsSave: _vm.needsSave,
        stop: _vm.stop
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }